module.exports = __webpack_public_path__ + "img/uso_quebra_ventos_4.074c0560.webp";